import { object, string } from 'yup';

export enum RequestPasswordResetFormStep {
  Email,
  LinkInstructions,
}

export interface FormValues {
  email: string;
}

export const validation = object({
  email: string().required('Please specify your email or username'),
});
